import { useState, useEffect } from 'react'
import api from '../../utils/api'
import AdminLayout from '../../components/admin/AdminLayout'
import './Admin.css'
import * as XLSX from 'xlsx'

export default function AdminEnrollments() {
  const [enrollments, setEnrollments] = useState<any[]>([])
  const [allEnrollments, setAllEnrollments] = useState<any[]>([])
  const [semesters, setSemesters] = useState<any[]>([])
  const [filterSemester, setFilterSemester] = useState<string>('')

  useEffect(() => {
    loadSemesters()
    loadEnrollments()
  }, [])

  useEffect(() => {
    filterEnrollments()
  }, [filterSemester, allEnrollments])

  const loadSemesters = async () => {
    try {
      const res = await api.get('/semesters')
      setSemesters(res.data)
    } catch (err) {
      console.error('학기 로드 오류:', err)
    }
  }

  const loadEnrollments = async () => {
    try {
      const res = await api.get('/admin/enrollments')
      setAllEnrollments(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const filterEnrollments = () => {
    if (!filterSemester) {
      setEnrollments(allEnrollments)
    } else {
      const filtered = allEnrollments.filter(e => e.semester_id === parseInt(filterSemester))
      setEnrollments(filtered)
    }
  }

  const exportToExcel = () => {
    if (enrollments.length === 0) {
      alert('반출할 데이터가 없습니다.')
      return
    }

    // 엑셀 데이터 형식 변환
    const excelData = enrollments.map((e, idx) => ({
      '번호': idx + 1,
      '성명': e.name,
      '소속기관': e.organization || '-',
      '학년도/계절': `${e.year}년 ${e.season}`,
      '강좌명': e.course_title,
      '교수명': e.instructor,
      '전화번호': e.phone || '-',
      '이메일': e.email || '-',
      '결의근거': e.reason || '-',
      '신청일': new Date(e.enrolled_at).toLocaleDateString('ko-KR')
    }))

    // 워크북 생성
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(excelData)

    // 컬럼 너비 설정
    ws['!cols'] = [
      { wch: 6 },  // 번호
      { wch: 10 }, // 성명
      { wch: 15 }, // 소속기관
      { wch: 12 }, // 학년도/계절
      { wch: 20 }, // 강좌명
      { wch: 10 }, // 교수명
      { wch: 15 }, // 전화번호
      { wch: 25 }, // 이메일
      { wch: 30 }, // 결의근거
      { wch: 12 }  // 신청일
    ]

    XLSX.utils.book_append_sheet(wb, ws, '수강신청')

    // 파일명 생성
    const selectedSemester = semesters.find(s => s.id === parseInt(filterSemester))
    const fileName = selectedSemester 
      ? `수강신청_${selectedSemester.year}년_${selectedSemester.season}.xlsx`
      : `수강신청_전체.xlsx`

    // 파일 다운로드
    XLSX.writeFile(wb, fileName)
  }

  return (
    <AdminLayout>
    <div className="admin-page">
      <h1>수강신청 관리</h1>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <div>
            <p style={{ margin: 0, color: '#666' }}>
              총 <strong>{enrollments.length}</strong>건의 수강신청이 있습니다.
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <button 
              onClick={exportToExcel}
              className="btn btn-success"
              disabled={enrollments.length === 0}
              style={{ padding: '0.5rem 1rem', whiteSpace: 'nowrap' }}
            >
              📊 엑셀 반출
            </button>
            <label style={{ fontWeight: 500 }}>학기 필터:</label>
            <select 
              value={filterSemester} 
              onChange={(e) => setFilterSemester(e.target.value)}
              style={{ padding: '0.5rem', borderRadius: '6px', border: '1px solid #ddd', minWidth: '150px' }}
            >
              <option value="">전체</option>
              {semesters.map(s => (
                <option key={s.id} value={s.id}>{s.year}년 {s.season}</option>
              ))}
            </select>
          </div>
        </div>

      <div className="admin-list">
        {enrollments.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '60px 20px', 
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '2px dashed #dee2e6'
          }}>
            <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '0.5rem' }}>
              ✍️ 수강신청 내역이 없습니다
            </p>
            <p style={{ color: '#999', margin: 0 }}>
              {filterSemester ? '선택한 학기의 수강신청이 없습니다.' : '등록된 수강신청이 없습니다.'}
            </p>
          </div>
        ) : (
        <table>
          <thead>
            <tr>
              <th>번호</th>
              <th>성명</th>
              <th>소속기관</th>
              <th>강좌명</th>
              <th>전화번호</th>
              <th>이메일</th>
              <th>결의근거</th>
              <th>신청일</th>
            </tr>
          </thead>
          <tbody>
            {enrollments.map((e, idx) => (
              <tr key={e.id}>
                <td>{idx + 1}</td>
                <td>{e.name}</td>
                <td>{e.organization || '-'}</td>
                <td>{e.course_title}</td>
                <td>{e.phone || '-'}</td>
                <td>{e.email || '-'}</td>
                <td>{e.reason || '-'}</td>
                <td>{new Date(e.enrolled_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
      </div>
    </div>
    </AdminLayout>
  )
}

